import { FC } from 'react';
import { Field, FastField } from 'formik';
import { NContact } from '@modules/ContactManager/components/Tabs/components/Contact/validation';
import { IAsset } from '@modules/ContactManager/components/Tabs/components/Assets/interfaces';
import { IOption } from '@shared/interfaces';
import { FormFieldLabel } from '@styles/Shared/StyledFormFields';
import { ICoApplicant } from '@modules/ContactManager/components/Tabs/components/Contact/components/CoApplicant/validation';
import { Normalizable } from '@shared/utils/helpers';
import { GridItem } from '../styledComponents';
import { deCamelize } from '../commonFunctions';
import { TextInputField } from '../fields/TextInputField';
import { Paths } from '../../../typings/global';

export interface IFormFieldConfig<T = object> {
  width?: string;
  name?: Paths<T> | string;
  label?: string;
  component?: FC<any>; // eslint-disable-line
  type?: string;
  tooltipMessage?: string;
  options?: IOption[];
  hidden?: boolean | false;
  [key: string]: unknown;
  onUpdate?: () => void;
  updateBtnLabel?: string;
  compareWith?: {
    contactPath?: string;
    assetPath?: string;
    coApplicantPath?: string;
    contactResolver?: (contact: NContact.Entity) => Normalizable;
    assetResolver?: (asset: IAsset) => Normalizable;
    coApplicantResolver?: (coApplicant: ICoApplicant) => Normalizable;
  }; 
}

interface IFormFieldsProps<T = object> {
  config: IFormFieldConfig<T>[];
  useFastFields?: boolean;
}

export const FormFields = ({ 
  config,
  useFastFields = false 
}: IFormFieldsProps) => {
  const fieldLabel = (name = '') => {
    const list = name.split('.');

    return deCamelize(list[list.length - 1]);
  };

  return (
    <>
      {config.map(({ width, minWidth, name, label, component, hidden, ...rest }, index) => (
        <GridItem key={index} width={width} minWidth={minWidth as string}>
          {rest?.type === 'other' ? component : rest?.type === 'label' ? (
            <FormFieldLabel>{label || deCamelize(name)}</FormFieldLabel>
          ) : useFastFields ? (
            !hidden && 
              <FastField
                {...rest}
                name={name}
                label={label || fieldLabel(name)}
                component={component || TextInputField}
              />
          ) : (
            !hidden && 
              <Field
                {...rest}
                name={name}
                label={label || fieldLabel(name)}
                component={component || TextInputField}
              />
          )}
        </GridItem>
      ))}
    </>
  );
};
